import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import VueSvgInlinePlugin from 'vue-svg-inline-plugin'
// import polyfills for IE if you want to support it
import 'vue-svg-inline-plugin/src/polyfills'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

Vue.config.productionTip = false
Vue.use(VueSvgInlinePlugin)

VueSvgInlinePlugin.install(Vue, {
  attributes: {
    data: ['src'],
    remove: ['alt']
  }
})

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')